import React from 'react';
import { CheckCircle, Zap, Users, TrendingUp } from 'lucide-react';
import { kioskImage } from '../utils/mockData';

const features = [
  { icon: CheckCircle, text: 'Compact & efficient design' },
  { icon: Zap, text: 'Fast service for busy professionals' },
  { icon: Users, text: 'High footfall optimization' },
  { icon: TrendingUp, text: 'Premium workplace experience' },
];

export const KioskSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#EBEBD3]/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              Our Kiosk Concept
            </h2>
            <div className="w-24 h-1 bg-[#FE9E1C] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Designed for high-footfall corporate environments with a perfect blend of efficiency and premium aesthetics
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Kiosk Image */}
            <div className="order-2 lg:order-1">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={kioskImage}
                  alt="Balanced Bites Cafe Kiosk"
                  className="w-full h-auto object-cover"
                />
                {/* Overlay Badge */}
                <div className="absolute top-6 left-6 bg-[#FE9E1C] text-white px-6 py-3 rounded-full font-bold shadow-lg">
                  Premium Design
                </div>
              </div>
            </div>

            {/* Features */}
            <div className="order-1 lg:order-2 space-y-8">
              <div className="space-y-6">
                {features.map((feature, index) => {
                  const Icon = feature.icon;
                  return (
                    <div
                      key={index}
                      className="flex items-start space-x-4 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 border border-[#EBEBD3]"
                    >
                      <div className="flex-shrink-0 w-12 h-12 bg-[#59642C]/10 rounded-xl flex items-center justify-center">
                        <Icon className="w-6 h-6 text-[#59642C]" strokeWidth={2} />
                      </div>
                      <p className="text-lg text-gray-700 font-medium pt-2">{feature.text}</p>
                    </div>
                  );
                })}
              </div>

              {/* Additional Info */}
              <div className="bg-gradient-to-br from-[#59642C] to-[#59642C]/90 p-8 rounded-3xl text-white shadow-lg">
                <h3 className="text-2xl font-bold mb-3">Built for Corporate Spaces</h3>
                <p className="text-white/90 leading-relaxed">
                  Our kiosks are meticulously designed to fit seamlessly into modern corporate environments, offering a premium cafe experience without taking up excessive space.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
